let searchTimer;                //timer identifier
let doneTypingInterval = 500;  //time in ms, 5 seconds for example

function preparePlugins(container)
{
    initSliders();
}

$(document).ready(function () {
    // switch table or rows layout
    $(document).on('click', "button.row-layout", function () {
        let button = $(this);
        if (button.hasClass('lock')) {
            return;
        }
        button.addClass('lock');

        let loader = $(document).find('.filter-loader');
        loader.show();
        $.nette.ajax({
            url: $(this).data("href"),
            type: 'GET',
            success: function () {
                $(".product").addClass("product-row");
                $(".row-off").addClass("off");
                $(".row-on").addClass("active");
                $(".table-off").addClass("active");
                $(".table-on").addClass("off");
                loader.hide();
                button.removeClass('lock');
            },
        });
    });

    $(document).on('click', "button.table-layout", function () {
        let button = $(this);
        if (button.hasClass('lock')) {
            return;
        }
        button.addClass('lock');

        let loader = $(document).find('.filter-loader');
        loader.show();
        $.nette.ajax({
            url: $(this).data("href"),
            type: 'GET',
            success: function () {
                $(".product").removeClass("product-row");
                $(".table-off").removeClass("active");
                $(".table-on").removeClass("off");
                $(".row-off").removeClass("off");
                $(".row-on").removeClass("active");
                loader.hide();
                button.removeClass('lock');
            },
        });
    });

});

function initSliders()
{
    // jQuery UI slider
    $(function () {
        let containers = $(document).find(".slider-range-container");
        containers.each(function () {
            let container = $(this);
            if (container.hasClass('inited')) {
                return;
            }
            let slider = container.find(".slider-range");
            if (slider) {
                let min = container.find(".min");
                let max = container.find(".max");

                let minVal = parseInt($(min).val());
                let maxVal = parseInt($(max).val());
                let minExtremeVal = parseInt($(min).data('min-price'));
                let maxExtremeVal = parseInt($(max).data('max-price'));
                slider.slider({
                    range: true,
                    min: minExtremeVal,
                    max: maxExtremeVal,
                    values: [minVal, maxVal],
                    slide: function (event, ui) {
                        if (isLocked === true) {
                            return;
                        }
                        clearTimeout(searchTimer);
                        if (ui.values[0] != minVal) {
                            $(min).val(ui.values[0]);
                            searchTimer = setTimeout(function () {
                                onChangeHandleMin(container);
                            }, doneTypingInterval);
                        } else if (ui.values[1] != maxVal) {
                            $(max).val(ui.values[1]);
                            searchTimer = setTimeout(function () {
                                onChangeHandleMax(container);
                            }, doneTypingInterval);
                        }
                    },
                });
                $(min).val(+slider.slider("values", 0));
                $(max).val(+slider.slider("values", 1));
                container.addClass('inited');
            }

        });

    });
}

function onChangeHandleMin(container)
{
    container.find(".min").trigger("change");
}

function onChangeHandleMax(container)
{
    container.find(".max").trigger("change");
}

function flashMessages()
{
    FLASHESS.forEach(function (v, k) {
        toastr[v.type](v.message);
    });

    FLASHESS.length = 0;

}

var navbar = document.getElementById("top-menu");
var sidebar = document.getElementById("mobile-nav");

var content = document.getElementById("content");

// Function to adjust the top property of the sidebar based on navbar height
function adjustSidebarTop()
{

    let sideBarTop = $(navbar).outerHeight(true) + 4;

    let sidebarOjb = $(sidebar);
    sidebarOjb.css('top', sideBarTop + "px");

    if (window.innerWidth < 1280) {
        content.style.paddingTop = navbar.offsetHeight + 4 + "px";
        sidebarOjb.css({
            'max-height': screen.availHeight - sideBarTop,
            'padding-bottom': '170px'
        });
    } else {
        content.style.paddingTop = 0;
        sidebarOjb.css({
            'max-height': 'unset'
        });
    }
}

window.addEventListener("resize", adjustSidebarTop);

$(document).ready(function () {

    preparePlugins($(document));
    flashMessages();
    adjustSidebarTop();

    $(document).on('keypress', function (e) {
        if (e.keyCode === 42) {
            $('#snippet--wish-list-area').slideToggle(300, function() {
                if ($(this).is(':visible')) {
                    let $textarea = $(this).find('.wish-area');
                    let textareaContent = $textarea.val();
                    let trimmedContent = textareaContent.trim();
                    let contentWithoutSpaces = trimmedContent.replace(/[ \t]+$/gm, '');
                    $textarea.val(contentWithoutSpaces);
                    $textarea.select();
                    document.execCommand("copy");
                    toastr.success('Obsah zdrojového úryvku byl zkopírován do schránky.');
                }
            });
        }
    });



    $('.clipboard-copy').click(function (e) {

        e.preventDefault();
        let btn = $(this);

        if ($(this).data('coppied')) {
            return;
        }

        console.log('.' + btn.attr('class'));
        let clipboard = new ClipboardJS('.' + btn.attr('class'));

        clipboard.on('success', function (e) {
            toastr['info'](btn.data('msg'));
            btn.data('coppied', true);
            selectAllText(btn.get(0));
        });

        clipboard.on('error', function (e) {
            console.error('Action:', e.action);
            console.error('Trigger:', e.trigger);
        });

    });


    $.nette.init();

    $.nette.ext({
        complete: function (payload) {
            preparePlugins($("body"));
            flashMessages();
            initSelect2ColorSize();
        }
    });

    if ($(document).find('#homepage-slider').length) {

        const swiper = new Swiper('#homepage-slider', {
            loop: true,
            autoResize: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 1,
            breakpoints: {
                1024: {
                    loop: false,
                    slidesPerView: 2,
                    spaceBetween: 32
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
        });
    }

    if ($(document).find('#about-slider').length) {

        const swiper = new Swiper('#about-slider', {
            loop: true,
            autoResize: true,
            slidesPerView: 4,
            breakpoints: {
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 26,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 32,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                640: {
                    slidesPerView: 3,
                    spaceBetween: 12,
                },
                470: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                },
                0: {
                    slidesPerView: 1,
                    spaceBetween: 8,
                }
            },
            autoplay: {
                delay: 800,
                disableOnInteraction: false
            },
        });
    }

    if ($(document).find('#news-slider').length) {
        const newsSwiper = new Swiper('#news-slider', {
            loop: true,
            autoResize: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 1,
            breakpoints: {
                1024: {
                    loop: false,
                    slidesPerView: 3,
                    spaceBetween: 32
                },
                768: {
                    loop: false,
                    slidesPerView: 2,
                    spaceBetween: 16
                }
            }
        });
    }

    lightbox.option({
        'resizeDuration': 300,
        'wrapAround': true
    });

});
